// Utils
import cn from '../../../utils/cn';

// Styles
import styles from './CustomVueListGroup.module.css';

/**
 * CustomVueListGroup
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @param {'default'|'wide'} [props.variant='default'] - Width variant
 * @returns {JSX.Element} CustomVueListGroup component
 */
function CustomVueListGroup({ children, variant = 'default' }) {
  return (
    <div className={cn([styles.container, styles[variant]])}>
      {children}
    </div>
  );
}

/**
 * CustomVueListGroupList
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @returns {JSX.Element} CustomVueListGroupList component
 */
export function CustomVueListGroupList({ children }) {
  return <div className={styles.list}>{children}</div>;
}

/**
 * CustomVueListGroupTitle
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @returns {JSX.Element} CustomVueListGroupTitle component
 */
export function CustomVueListGroupTitle({ children }) {
  return <p className={styles.title}>{children}</p>;
}

export default CustomVueListGroup;
